import { useState } from 'react'
import React from 'react'
import { FormWrapper } from './styled.js'
import FormStarRating from 'components/FormStarRating'
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from 'redux/selector.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { rattingCommentActions } from "redux/slice/rattingCommentSlice"

function RattingComment({ tourId, callBack }) {
    const [numberStar, setNumberStar] = useState(5)
    const authState = useSelector(authSelector)
    const navigate = useNavigate()
    const location = useLocation();
    const pathname = location.pathname;
    const [inputCommentRatting, setInputCommentRating] = useState('')
    const dispatch = useDispatch()


    const handleSentRatting = () => {
        if (!authState.isLoggedIn) return navigate("/login", { state: { pathname } });
        const data = {
            tour_id: tourId,
            content: inputCommentRatting.trim(),
            star: numberStar
        }
        dispatch(rattingCommentActions.create({ data, callBack, setInputCommentRating, isRate: true }))

    }


    return (
        <FormWrapper >

            <div className={'rating_form'}>
                <h6>Đánh giá </h6>
                <FormStarRating
                    numberStar={numberStar}
                    setNumberStar={setNumberStar}
                />
                <textarea className='b-grey-1 mt-10' placeholder='Viết đánh giá của bạn' onChange={e => setInputCommentRating(e.target.value)} value={inputCommentRatting}></textarea>
                <button onClick={handleSentRatting}> Gửi <i className='ti-check'></i>
                </button>
            </div>
        </FormWrapper>
    )
}

export default RattingComment